import { apiGet } from "utils/apiClient";

/** CoinGecko price response: { [coingeckoId]: { usd: number, usd_24h_change?: number } } */
export type CryptoPricesResponse = Record<string, { usd?: number; usd_24h_change?: number }>;

export async function fetchCryptoPrices(ids: string[]): Promise<CryptoPricesResponse> {
  if (ids.length === 0) return {};
  const idsParam = ids.join(",");
  const res = await apiGet<CryptoPricesResponse>(`/market/crypto/prices?ids=${encodeURIComponent(idsParam)}`);
  return res ?? {};
}
